var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessCardFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240.94 155.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8ccfb7;}.cls-2{fill:#082340;}.cls-2,.cls-3{font-family:CFArmadilloStd-Medium, 'CF Armadillo Std';font-size:9px;font-weight:500;}.cls-3{fill:#6dc067;}.cls-4{fill:#fffef9;}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath);}.cls-7{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 47.6,
    y: 60.96,
    width: 145.75,
    height: 34.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 47.6,
    y: 60.96,
    width: 145.75,
    height: 34.28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 240.94,
    height: 155.91
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(47.6 53.31)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "www.capio.com")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(106.89 108.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "trade feels good here")), /*#__PURE__*/React.createElement("g", {
    id: "capio_simple"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m152.22,66.12c0-1.27.39-2.35,1.16-3.26,1.02-1.2,2.57-1.83,4.15-1.83h30.72c1.4,0,2.59.49,3.6,1.47,1,.98,1.5,2.19,1.5,3.63v24.02c0,1.44-.5,2.65-1.5,3.63-1,.98-2.2,1.47-3.6,1.47h-30.73c-1.58,0-3.13-.63-4.15-1.84-.77-.91-1.16-1.99-1.16-3.26v-24.02Zm36.24,24.45v-24.88c0-.07-.06-.13-.13-.13h-30c-.68,0-1.23.55-1.23,1.23v22.69c0,.68.55,1.23,1.23,1.23h30c.07,0,.13-.06.13-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.2,95.23h-15.49c-1.4,0-2.6-.49-3.6-1.47-1-.98-1.5-2.2-1.5-3.64v-24.06c0-1.45.5-2.66,1.5-3.64,1.01-.98,2.2-1.47,3.6-1.47h15.49v4.55h-15.7v25.18h15.7v4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.48,62.42c-1-.98-2.2-1.47-3.6-1.47h-15.49v4.55h15.7v8.74h-22.81c-1.4,0-2.6.49-3.6,1.47-1,.98-1.5,2.2-1.5,3.64v10.77c0,1.45.5,2.66,1.5,3.64,1.01.98,2.2,1.47,3.6,1.47h22.59c1.4,0,2.6-.49,3.6-1.47,1.01-.98,1.5-2.19,1.5-3.64v-24.06c0-1.44-.5-2.66-1.5-3.64m-3.39,28.26h-23.01v-11.89h23.01v11.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.46,95.23h-4.66v-22.3c-2.68,0-5.35-.01-8.03-.02v-7.41h-32.1v13.29h32.11v-1.56h4.89c.05.97-.03,1.71-.1,2.07-.1.49-.27.89-.27.89-.08.19-.39.92-1.1,1.64-.11.11-.22.21-.33.3-.92.81-2.02,1.21-3.31,1.21h-31.89v11.89h-4.9v-29.17c0-1.44.5-2.66,1.5-3.64,1-.98,2.21-1.47,3.61-1.47h31.68c1.4,0,2.6.49,3.61,1.47,1,.98,1.5,2.2,1.5,3.64v1.97h7.74c.02,8.81.03,18.39.05,27.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.96,60.96h0c1.35,0,2.45,1.1,2.45,2.45v.77c0,1.35-1.1,2.45-2.45,2.45s-2.45-1.1-2.45-2.45v-.77c0-1.35,1.1-2.45,2.45-2.45"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCardFront);
export default __webpack_public_path__ + "static/media/business-card-front.82a065285893a842ca3b1fb79adc659c.svg";
export { ForwardRef as ReactComponent };